import React from "react";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const CTASection = ({
  title,
  description,
  primaryLabel = "Contact Refwa",
  primaryTo = "/contact",
  secondaryLabel,
  secondaryTo,
}) => (
  <Box className="site-section">
    <Container>
      <Box
        sx={{
          borderRadius: "var(--radius-panel)",
          px: { xs: 3, md: 5, lg: 6 },
          py: { xs: 4, md: 4.8, lg: 5.4 },
          color: "#fff",
          background:
            "linear-gradient(135deg, #101a2b 0%, #16263d 48%, #8d6330 100%)",
          boxShadow: "var(--shadow-hero)",
          position: "relative",
          overflow: "hidden",
          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "88px 88px",
            opacity: 0.14,
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 3, md: 4 }}
          alignItems="center"
          sx={{ position: "relative", zIndex: 1 }}
        >
          <Grid item xs={12} lg={8}>
            <Box
              className="eyebrow"
              sx={{
                color: "#fff",
                "&::before": {
                  background:
                    "linear-gradient(90deg, rgba(255,255,255,0.14), #dec095)",
                },
              }}
            >
              Contact Refwa
            </Box>
            <Typography variant="h3" sx={{ mt: 1.6, maxWidth: 760 }}>
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 2, maxWidth: 720, color: "rgba(255,255,255,0.82)" }}
            >
              {description}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Stack
              spacing={1.8}
              sx={{
                p: { xs: 0, lg: 2.2 },
                borderRadius: { lg: 0.5 },
                backgroundColor: { lg: "rgba(255,255,255,0.05)" },
                border: { lg: "1px solid rgba(255,255,255,0.1)" },
              }}
            >
              <Button
                component={RouterLink}
                to={primaryTo}
                variant="contained"
                size="large"
                fullWidth
              >
                {primaryLabel}
              </Button>
              {secondaryLabel && secondaryTo ? (
                <Button
                  component={RouterLink}
                  to={secondaryTo}
                  variant="outlined"
                  size="large"
                  fullWidth
                  sx={{
                    color: "#fff",
                    borderColor: "rgba(255,255,255,0.32)",
                    bgcolor: "rgba(255,255,255,0.03)",
                    "&:hover": {
                      borderColor: "#fff",
                      backgroundColor: "rgba(255,255,255,0.06)",
                    },
                  }}
                >
                  {secondaryLabel}
                </Button>
              ) : null}
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default CTASection;
